export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";